import { render, staticRenderFns } from "./TransferenciasCadastro.vue?vue&type=template&id=44541c58&scoped=true&"
import script from "./TransferenciasCadastro.vue?vue&type=script&lang=js&"
export * from "./TransferenciasCadastro.vue?vue&type=script&lang=js&"
import style0 from "./TransferenciasCadastro.vue?vue&type=style&index=0&id=44541c58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44541c58",
  null
  
)

export default component.exports